export const pendingWebsocketActionTypes = {
  issueRefund: 'issueRefund',
  schedulePickup: 'schedulePickup',
  changeDeliveryMethod: 'changeDeliveryMethod',
  createExchangeOrder: 'createExchangeOrder',
  validateTransaction: 'validateTransaction',
  changeTransactionStatus: 'changeTransactionStatus',
  markAsPaid: 'markAsPaid',
  markAsIssued: 'markAsIssued',
  changeRefundMethod: 'changeRefundMethod',
  generateLabel: 'generateLabel',
}

export const loadingByWebsocketActionType = {
  [pendingWebsocketActionTypes.issueRefund]: { summaryCard: true, detailCard: true },
  [pendingWebsocketActionTypes.schedulePickup]: { shippingDetailsCard: true },
  [pendingWebsocketActionTypes.changeDeliveryMethod]: { shippingDetailsCard: true, documentsCard: true },
  [pendingWebsocketActionTypes.createExchangeOrder]: { detailCard: true },
  [pendingWebsocketActionTypes.validateTransaction]: {
    summaryCard: true,
    detailCard: true,
    lineItemsToReturnCard: true,
  },
  [pendingWebsocketActionTypes.changeTransactionStatus]: { fullPage: true },
  [pendingWebsocketActionTypes.markAsPaid]: { summaryCard: true, detailCard: true },
  [pendingWebsocketActionTypes.markAsIssued]: { summaryCard: true, detailCard: true },
  [pendingWebsocketActionTypes.changeRefundMethod]: { summaryCard: true, detailCard: true },
  [pendingWebsocketActionTypes.generateLabel]: { shippingDetailsCard: true, documentsCard: true },
}
